import { useEffect } from 'react';
import { useActionCreators, useStateSelector } from 'shared/store';
import { invoiceBasicsThunks } from './thunks';

export const useInvoiceBasics = (invoiceId: number) => {
  const { fetchInvoiceBasicsThunk } = useActionCreators(invoiceBasicsThunks);

  useEffect(() => {
    fetchInvoiceBasicsThunk(invoiceId);
  }, [fetchInvoiceBasicsThunk, invoiceId]);

  return {
    data: useInvoiceMutableData(),
    error: useStateSelector(state => state.invoiceMutableData.meta.error),
    isLoading: useStateSelector(state => state.invoiceMutableData.meta.status === 'loading'),
    reload: () => fetchInvoiceBasicsThunk(invoiceId)
  };
};

export const useInvoiceMutableData = () => {
  return useStateSelector(state => state.invoiceMutableData.data);
};
